import React from "react";
import { Link } from "react-router-dom";
import { Loading } from "../../../../../Other/Loading";
import OverlayContainer from "../../../../../Overlay/OverlayContainer";

const CourseSubmit = ({ closeHandler, response, loaded, submit }) => {
  return (
    <>
      {!loaded ? (
        <OverlayContainer>
          <div className="alert-dialog-inner">
            <div className="close-wrapper" onClick={() => submit(false)}>
              <i className="icon check"></i>
            </div>
            {response.error === false ? (
              <div>
                <div className="alert-title">
                  <img
                    src="https://cdn.edusity.com/icons/icon-complete-check.svg"
                    alt="check-complete"
                  />
                </div>
                <h3 className="success">Success</h3>
                <p className="alert-title ">{response.data.courseType==="liveCourse"?"Webinar Successfully update":response?.message}</p>
              </div>
            ) : (
              <div>
                <div className="alert-title">
                  <img
                    src=" https://cdn.edusity.com/icons/icon-failure-check.svg"
                    alt="check-error"
                  />
                </div>
                <h3 className="error">Invalid Error</h3>
                <p className="alert-title">
                  {response?.data?.length > 0 && response?.data[0]?.msg}
                </p>
              </div>
            )}

            <div className="alert-close-btn">
              {response.error === false ? (
                <Link to="/dashboard" className="btn-save">
                  Go to Dashboard
                </Link>
              ) : (
                <Link className="btn-save" onClick={() => closeHandler()}>
                  Cancel
                </Link>
              )}
            </div>
          </div>
        </OverlayContainer>
      ) : (
        <OverlayContainer>
          <div className="alert-dialog-inner">
            <Loading />
          </div>
        </OverlayContainer>
      )}
    </>
  );
};
export default CourseSubmit;
